import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { graphcms, QUERY_GALLERY_BY_ID } from "../Graphql/Queries";
import { Skeleton } from "@/components/ui/skeleton";

function EachGallery() {
  const { galleryID } = useParams();
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);

  let photos = [];

  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  useEffect(() => {
    graphcms
      .request(QUERY_GALLERY_BY_ID, { galleryID })
      .then((res) => {
        setGalleryImages(res.galleries[0]);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  galleryImages.pictures?.map((image, index) => {
    photos[index] = {
      src: image.url,
      width: image.width,
      height: image.height,
      srcSet: [
        `${image.url} 500w`,
        `${image.url} 800w`,
        `${image.url} 1024w`,
        `${image.url} 1600w`,
      ],
      sizes: ["(min-width: 480px) 50vw,(min-width: 1024px) 33.3vw,100vw"],
    };
  });

  return (
    <div className="mt-10 mb-20 w-11/12 container mx-auto">
      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-64 w-full rounded-md" />
          ))}
        </div>
      ) : (
        <div>
          <h2 className="text-xl font-bold text-center mb-10">
            {galleryImages?.eventCategoryName}
          </h2>
          <Gallery photos={photos} onClick={openLightbox} />
          <ModalGateway>
            {viewerIsOpen ? (
              <Modal onClose={closeLightbox}>
                <Carousel
                  className="margin: 0 auto"
                  currentIndex={currentImage}
                  views={photos.map((x) => ({
                    ...x,
                    srcset: x.srcSet,
                    caption: x.title,
                  }))}
                />
              </Modal>
            ) : null}
          </ModalGateway>
        </div>
      )}
    </div>
  );
}

export default EachGallery;
